<template>
    <div>
        <rkm-modal
            extra-large
            ref="RkmModal"
            title="Notas de versão"
        >
            <rkm-table
                :fields="fields"
                :items="items"
            >
                <template v-slot:cell(actions)="{item}">
                    <rkm-button
                        @click="$refs.ModalMensagem.open(item)"
                        color="primary"
                        small
                        title="Mensagem"
                    >
                        <rkm-icon icon="search" />
                    </rkm-button>
                </template>
            </rkm-table>

            <template v-slot:footer="{cancel}">
                <rkm-button
                    :disabled="!!loading"
                    @click="cancel"
                    color="secondary"
                >
                    Fechar
                </rkm-button>
            </template>
        </rkm-modal>

        <ModalMensagem ref="ModalMensagem" />
    </div>
</template>

<script>
// Components.
import ModalMensagem from './components/mensagem/Modal'

// Mixins.
import {error, repository} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {ModalMensagem},
    computed: {
        ...mapGetters({loading: 'getLoading'}),
    },
    created() {
        this.repositories = {
            notaVersao: this.getConectaSusRepository('intranet.cadastro.notaVersao'),
        }
    },
    data: () => ({
        fields: [
            {key: 'versao', label: 'Versão'},
            {key: 'titulo', label: 'Título'},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
        items: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {
            this.load()
            this.$refs.RkmModal.show()
        },
        load() {
            this.setLoading()

            this.repositories.notaVersao.index()
                .then(response => this.items = Object.assign(response.data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, repository],
}
</script>